import  { useEffect, useState } from 'react';
import { 
  Form,
  Row,
  Col,
  Card, 
  Tag, 
  Divider, 
  Typography, 
  Collapse,
  Input,
  notification,
  Button
} from 'antd';
import { 
  MailOutlined, 
  PhoneOutlined, 
  CalendarOutlined,
} from '@ant-design/icons';
import classes from "../../../Etablissements/Etablissements.module.css";
import { getDetailsApprenants } from '../../../../api/geoprod';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomUpload from '../../../../utils/CustomUpload';
import { useLoader } from '../../../../context/LoaderContext';
import dayjs from "dayjs";
import { CircleArrowLeft } from 'lucide-react';
const { Title, Text } = Typography;
const { Panel } = Collapse;

const DetailsApprenant = () => {
  const { idApprenant } = useParams();
  const [apprenantData, setApprenantData] = useState(null);
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { setIsLoading} = useLoader();
  useEffect(() => {
    const fetchData = async () => {
        setIsLoading(true)
     getDetailsApprenants(idApprenant)
     .then((response)=>{
       setApprenantData(response);
        form.setFieldsValue({
          ...response.mainProspect,
         
        });
        setIsLoading(false)
     })
     .catch((error)=>
    {
      notification.error({
              message: t("Erreur"),
              description: t(error?.data?.message),
              duration: 0,
            });
            setIsLoading(false);
    })
      
    
    };

    fetchData();
  }, []);




  const { mainProspect, sessions } = apprenantData || {};
  return apprenantData && (
    
    <div >
      
               <Button
                className={classes.buttonCreate}
                onClick={() => navigate(-1)}
                style={{marginInline:"16px"}}
      
              >
                <CircleArrowLeft strokeWidth={1.25} />
                {t("Précédent")}
              </Button>
      <Card 
        title="Informations de l'apprenant" 
        style={{ marginBottom: '24px', paddingInline:"20px" }}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item label={t("Nationalité")} name="nationality">
                <Input readOnly />
              </Form.Item>
            </Col>

             {mainProspect?.nationality === "تونسية" && mainProspect?.etablissement_formation_origine && (
              <Col xs={24} sm={8}>
                <Form.Item label={t("Établissement de formation d'origine")} name={"etablissement_formation_origine"}>
                  <Input readOnly />
                </Form.Item>
              </Col>
            )}


             {mainProspect?.nationality !== "تونسية" && mainProspect?.etablissement_formation_origine_autre && (
              <Col xs={24} sm={8}>
                <Form.Item label={t("Établissement de formation d'origine")} name={"etablissement_formation_origine_autre"}>
                  <Input readOnly />
                </Form.Item>
              </Col>
            )}



            {mainProspect?.nationality === "تونسية" && mainProspect?.etablissement_formation_origine_autre  && 
             mainProspect?.etablissement_formation_origine === parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_EQUIVALENCE) && (
              <Col xs={24} sm={8}>
                <Form.Item label={t("Nom du diplôme")} name="etablissement_formation_origine_autre">
                  <Input readOnly />
                </Form.Item>
              </Col>
            )}
            {mainProspect?.DN &&(

            <Col xs={24} sm={8}>
              <Form.Item label={t("Date de naissance")} name="DN">
                <Input suffix={<CalendarOutlined />} readOnly />
              </Form.Item>
            </Col>
)}
            {mainProspect?.nationality === "تونسية" &&  mainProspect?.cin &&(
              <Col xs={24} sm={8}>
                <Form.Item label={t("Numéro CIN")} name="cin">
                  <Input readOnly />
                </Form.Item>
              </Col>
            )}

            {mainProspect?.nationality === "تونسية" && mainProspect?.extrait_naissance && (
              <Col xs={24} sm={8}>
                <Form.Item label={t("Numéro de l'extrait de naissance")} name="extrait_naissance">
                  <Input readOnly />
                </Form.Item>
              </Col>
            )}

            {mainProspect?.id_ministry && mainProspect?.nationality === "تونسية" && (
              <Col xs={24} sm={8}>
                <Form.Item 
                  label={mainProspect.etablissement_formation_origine === parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_MINISTERE_EDUCATION) 
                    ? t("Identifiant du ministère de l'éducation") 
                    : t("Identifiant du ministère de l'enseignement supérieur")} 
                  name="id_ministry"
                >
                  <Input readOnly />
                </Form.Item>
              </Col>
            )}

            {mainProspect?.nationality !== "تونسية" && (
              <>
               {mainProspect?.passport && (
                <Col xs={24} sm={8}>
                  <Form.Item label={t("N° passeport")} name="passport">
                    <Input readOnly />
                  </Form.Item>
                </Col>
               )}
               {mainProspect?.expiration_passeport && (

                <Col xs={24} sm={8}>
                  <Form.Item label={t("Date d'expiration du passeport")} name="expiration_passeport">
                    <Input suffix={<CalendarOutlined />} readOnly />
                  </Form.Item>
                </Col>)}

                {mainProspect?.carde_number && (
                  <Col xs={24} sm={8}>
                    <Form.Item label={t("Numéro de la carte séjour")} name="carde_number">
                      <Input readOnly />
                    </Form.Item>
                  </Col>
                )}
              </>
            )}

                {mainProspect?.name && (

            <Col xs={24} sm={8}>
              <Form.Item label={t("Nom (En français)")} name="name">
                <Input readOnly />
              </Form.Item>
            </Col>)}
            
                {mainProspect?.surname && (

            <Col xs={24} sm={8}>
              <Form.Item label={t("Prénom (En français)")} name="surname">
                <Input readOnly />
              </Form.Item>
            </Col>)}
                {mainProspect?.name_ar && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Nom (En arabe)")} name="name_ar">
                <Input readOnly />
              </Form.Item>
            </Col>)}
                {mainProspect?.surname_ar && (

            <Col xs={24} sm={8}>
              <Form.Item label={t("Prénom (En arabe)")} name="surname_ar">
                <Input readOnly />
              </Form.Item>
            </Col>
                )}
                {mainProspect?.lieu_naissance && (
              
            <Col xs={24} sm={8}>
              <Form.Item label={t("Lieu de naissance (En arabe)")} name="lieu_naissance">
                <Input readOnly />
              </Form.Item>
            </Col>)}
                {mainProspect?.goverment && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Gouvernorat de résidence")} name="goverment">
                <Input readOnly />
              </Form.Item>
            </Col>)}
                {mainProspect?.delegation && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Délégation de résidence")} name="delegation">
                <Input readOnly />
              </Form.Item>
            </Col>)}
                {mainProspect?.code_postal && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Code postal")} name="code_postal">
                <Input readOnly />
              </Form.Item>
            </Col>)}

            {mainProspect.nationality === "تونسية" && (
              <>
                {mainProspect?.nom_pere && (

                <Col xs={24} sm={8}>
                  <Form.Item label={t("Nom du père (En français)")} name="nom_pere">
                    <Input readOnly />
                  </Form.Item>
                </Col>)}
                {mainProspect?.nom_mere && (
                
                <Col xs={24} sm={8}>
                  <Form.Item label={t("Nom de la mère (En français)")} name="nom_mere">
                    <Input readOnly />
                  </Form.Item>
                </Col>)}
                {mainProspect?.nom_pere_ar && (

                <Col xs={24} sm={8}>
                  <Form.Item label={t("Nom du père (En arabe)")} name="nom_pere_ar">
                    <Input readOnly />
                  </Form.Item>
                </Col>)}
                {mainProspect?.nom_mere_ar && (

                <Col xs={24} sm={8}>
                  <Form.Item label={t("Nom de la mère (En arabe)")} name="nom_mere_ar">
                    <Input readOnly />
                  </Form.Item>
                </Col>)}
              </>
            )}
                {mainProspect?.civilite && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Genre")} >
                <Input readOnly value={mainProspect.civilite === "Mme" ? "Féminin - أنثى" : "Masculin - ذكر"} />
              </Form.Item>
            </Col>)}
                {mainProspect?.etat_civile && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("État civil")} name="etat_civile">
                <Input readOnly />
              </Form.Item>
            </Col>)}
                {mainProspect?.adresse_mail && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Adresse e-mail")} name="adresse_mail">
                <Input suffix={<MailOutlined />} readOnly />
              </Form.Item>
            </Col>
                )}
                {mainProspect?.tel && (

            <Col xs={24} sm={8}>
              <Form.Item label={t("Numéro de téléphone")} name="tel">
                <Input suffix={<PhoneOutlined />} readOnly />
              </Form.Item>
            </Col>)} 
               {mainProspect?.niveaux_education_name && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Niveau d'éducation")} name="niveaux_education_name">
                <Input readOnly />
              </Form.Item>
            </Col>)}


             {mainProspect?.niveaux_education_autre && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Autre niveau d'éducation")} name="niveaux_education_autre">
                <Input readOnly />
              </Form.Item>
            </Col>)}



              {mainProspect?.statuts_professionnels_name && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Statut actuel")} name="statuts_professionnels_name">
                <Input readOnly />
              </Form.Item>
            </Col>)}





              {mainProspect?.statuts_professionnels_autre && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Autre statut actuel")} name="statuts_professionnels_autre">
                <Input readOnly />
              </Form.Item>
            </Col>)}


        {mainProspect?.employeur_actuel && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Employeur actuel")} name="employeur_actuel">
                <Input readOnly />
              </Form.Item>
            </Col>)}


            
        {mainProspect?.fonctions_postes_name && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Fonction/Poste occupé")} name="fonctions_postes_name">
                <Input readOnly />
              </Form.Item>
            </Col>)}


          {mainProspect?.fonctions_postes_autre && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Autre Fonction/Poste occupé")} name="fonctions_postes_autre">
                <Input readOnly />
              </Form.Item>
            </Col>)}



                {mainProspect?.niveau_etud && (
            
            <Col xs={24} sm={8}>
              <Form.Item label={t("Niveau scolaire")} name="niveau_etud">
                <Input readOnly />
              </Form.Item>
            </Col>)}
            
                {mainProspect?.besoin_specifique  !== undefined &&   (

            <Col xs={24} sm={8}>
              <Form.Item label={t("Personne à besoin spécifique")}>
                <Input readOnly value={mainProspect?.besoin_specifique === 1 ? "Oui - نعم" : "Non - لا"} />
              </Form.Item>
            </Col>
                )}



                {mainProspect?.documents?.content_diplome && (

            <Col xs={24} sm={8}>
              <Form.Item label={t("Diplôme")}>
               
                  <CustomUpload
                    field={{
                      buttonName: "Diplôme",
                      name: mainProspect?.documents?.name_diplome || "Diplôme",
                    }}
                    multiple={false}
                    accept=".png,.jpg,.jpeg,.pdf"
                    customRequest={null}
                    id={"diplome"}
                    setSelectedDiplomaFiles={null}
                    type="diplome"
                    value={mainProspect?.documents?.content_diplome}
                    showIcon={false}
                    style={{ width: '100%' }}
                  />
               
              </Form.Item>
            </Col>)}
          </Row>
        </Form>
      </Card>

   

  {sessions?.length > 0 && (
    <Collapse accordion>
      {sessions.map((session, index) => (
        <Panel 
          header={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Text strong style={{ fontSize: '16px', marginRight:"10px" }}>{session?.specialite}</Text>
                <Tag color="#108ee9">{session.type_session}</Tag>
              </div>
              <Tag 
                color={session.couleur_background_statut}
                style={{ fontSize: '14px', color: session.couleur_statut }}
              >
                {session.statut_apprenant}
              </Tag>
            </div>
          } 
          key={index}
        >
        
            <Divider orientation="left">Informations de la session</Divider>
            <Row gutter={24}>
               <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Text strong>Date début    </Text>
                  <Text>{dayjs(session?.date_debut_formation)?.format("DD/MM/YYYY")}</Text>
                  </Col>
                     <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Text strong>Date fin   </Text>
                  <Text>{dayjs(session?.date_fin_session)?.format("DD/MM/YYYY")}</Text>
                  </Col>
            </Row>
     


  {(session?.id_contrat ===  import.meta.env.VITE_APP_REAL_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE&&
         <>
<Divider orientation="left">Attestations</Divider>

            <Row gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Text strong style={{ display: 'block', marginBottom: '8px' }}>Attestation de pré-inscription</Text>
                  {session.attestation_pre_inscription?.file_name  && session.attestation_pre_inscription?.url ? (
                    <CustomUpload
                      field={{
                        buttonName: "Télécharger",
                        name: session.attestation_pre_inscription.file_name || "Attestation pré-inscription",
                      }}
                      multiple={false}
                      accept=".png,.jpg,.jpeg,.pdf"
                      customRequest={null}
                      id={"attestation_pre"}
                      setSelectedDiplomaFiles={null}
                      type="attestation"
                      value={session.attestation_pre_inscription.url}
                      showIcon={false}
                      style={{ width: '100%' }}
                    />
                  ) : <Text type="secondary">Aucune attestation disponible</Text>}
              </Col>
              {/* <Col span={12}>
                <div style={{ marginBottom: '16px' }}>
                  <Text strong style={{ display: 'block', marginBottom: '8px' }}>Attestation d'inscription</Text>
                  {session.attestation_inscription?.length > 0 ? (
                    <List
                      dataSource={session.attestation_inscription}
                      renderItem={(item, idx) => (
                        <List.Item style={{ padding: '8px 0' }}>
                          <CustomUpload
                            field={{
                              buttonName: `Version ${item.version}`,
                              name: `Attestation inscription v${item.version}`,
                            }}
                            multiple={false}
                            accept=".png,.jpg,.jpeg,.pdf"
                            customRequest={null}
                            id={`attestation_inscription_${idx}`}
                            setSelectedDiplomaFiles={null}
                            type="attestation"
                            value={item.url}
                            showIcon={false}
                            style={{ width: '100%' }}
                          />
                        </List.Item>
                      )}
                    />
                  ) : <Text type="secondary">Aucune attestation disponible</Text>}
                </div>
              </Col> */}
            </Row></>
  )}

          {/* <div style={{ margin: '16px 0' }}>
            <Title level={5} style={{ marginBottom: '12px' }}>Attestations de présence</Title>
            {session.attestation_presence?.length > 0 ? (
              <Row gutter={24}>
                {session.attestation_presence.map((attestation, idx) => (
                  <Col span={8} key={idx}>
                    <CustomUpload
                      field={{
                        buttonName: `Version ${attestation.version}`,
                        name: `Attestation présence v${attestation.version}`,
                      }}
                      multiple={false}
                      accept=".png,.jpg,.jpeg,.pdf"
                      customRequest={null}
                      id={`attestation_presence_${idx}`}
                      setSelectedDiplomaFiles={null}
                      type="attestation"
                      value={attestation.url}
                      showIcon={false}
                      style={{ width: '100%' }}
                    />
                  </Col>
                ))}
              </Row>
            ) : <Text type="secondary">Aucune attestation de présence disponible</Text>}
          </div> */}

{
  session?.id_contrat ===  import.meta.env.VITE_APP_REAL_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE&&
  (
    <>
<Divider orientation="left">Evaluation</Divider>
 <Row gutter={24} style={{display:"flex", alignItems:"center",}}>
           
                <Col xs={24} sm={6}>
                  <Text strong>Résultat </Text>
                  <Tag color="green">
                    {session.resultat || '_'}
                  </Tag>
              </Col>
                    <Col xs={24} sm={6}>
                    <Text strong>Mention </Text>
                  <Tag color={"green"}>
                    {session.mention_apprenant || '_'}
                  </Tag>
                  </Col>
                     <Col xs={24} sm={12}>
                  <Text strong style={{ display: 'block', marginBottom: '8px' }}>Diplôme</Text>
                  {session?.diplome?.url && session?.diplome?.file_name? (
                    <CustomUpload
                      field={{
                        buttonName: "Télécharger",
                        name: session.diplome.file_name ,
                      }}
                      multiple={false}
                      accept=".png,.jpg,.jpeg,.pdf"
                      customRequest={null}
                      id={"diplome"}
                      setSelectedDiplomaFiles={null}
                      type="diplome"
                      value={session.diplome.url}
                      showIcon={false}
                    />
                  ) : <Text type="secondary">Aucun diplôme disponible</Text>}
              </Col>
            </Row>
</>
  )
}
      

<Divider orientation="left">Procès-Verbaux (PV)</Divider>

  
  {session.documents?.length > 0 ? (
    session.documents.map((doc, docIndex) => (
      <div key={docIndex} style={{ marginBottom: '24px' }}>
        <Text strong style={{ display: 'block', marginBottom: '16px', fontSize: '15px' }}>
          {doc.annee}
        </Text>
        
        <Row gutter={16}>
          {doc.periodes.map((periode, periodeIndex) => {
            const dernierDoc = periode.urls?.[periode.urls.length - 1];
            
            return (
              <Col xs={24} sm={24} md={12} lg={12} xl={12} key={periodeIndex}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  paddingInline: "30px",
               
                }}>
                  <span style={{ 
                    fontWeight: 600, 
                    marginRight: '12px', 
                    color: '#3f51b5',
                  }}>
                    {periode.periode} :
                  </span>
                  
                    {dernierDoc ? (
                      <CustomUpload
                        field={{
                          buttonName: "Télécharger PV",
                          name: `PV_${doc.annee}_${periode.periode}`,
                        }}
                        multiple={false}
                        accept=".png,.jpg,.jpeg,.pdf"
                        customRequest={null}
                        id={`pv_${docIndex}_${periodeIndex}`}
                        setSelectedDiplomaFiles={null}
                        type="attestation"
                        value={dernierDoc}
                        showIcon={false}
                        style={{ width: '100%' }}
                      />
                    ) : (
                      <Text type="secondary">Aucun PV disponible</Text>
                    )}
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    ))
  ) : (
    <Text type="secondary">Aucun procès-verbal disponible</Text>
  )}

        </Panel>
      ))}
    </Collapse>
  ) }
    </div>
  );
};

export default DetailsApprenant;